import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { assets } from "../lib/assets";
import { getChildProfileDetails, recordAccountEvent, type ChildProfileDetails } from "../services/auth/account";
import { supabase } from "../services/supabase/client";
import { useAppStore } from "../store/useAppStore";

const genderLabels = { girl: "女孩", boy: "男孩", unspecified: "未设置" } as const;
const stageLabels: Record<string, string> = {
  kindergarten_small: "幼儿园小班",
  kindergarten_middle: "幼儿园中班",
  kindergarten_large: "幼儿园大班",
  preschool: "学前阶段",
  primary_1: "小学一年级"
};

function ageFromBirthDate(value?: string | null) {
  if (!value) return null;
  const birth = new Date(`${value}T00:00:00`);
  const today = new Date();
  let age = today.getFullYear() - birth.getFullYear();
  if (today.getMonth() < birth.getMonth() || (today.getMonth() === birth.getMonth() && today.getDate() < birth.getDate())) age -= 1;
  return age >= 0 ? age : null;
}

export function ProfilePage() {
  const { activeChildId, childName, avatarUrl, stars } = useAppStore();
  const [profile, setProfile] = useState<ChildProfileDetails | null>(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    let alive = true;
    if (!activeChildId) return;
    void getChildProfileDetails(activeChildId).then((data) => { if (alive) setProfile(data); }).catch(() => undefined);
    return () => { alive = false; };
  }, [activeChildId]);

  async function signOut() {
    setBusy(true);
    if (activeChildId) await recordAccountEvent(activeChildId, "account.logout");
    await supabase?.auth.signOut();
    localStorage.removeItem("lusky:active-profile");
    setBusy(false);
  }

  const age = ageFromBirthDate(profile?.birth_date);
  const profileSummary = [
    profile?.gender ? genderLabels[profile.gender] : "性别未设置",
    age === null ? "年龄未设置" : `${age} 岁`,
    profile?.school_stage ? stageLabels[profile.school_stage] : "学龄未设置"
  ];

  return <section className="profile-page page-view">
    <article className="profile-identity">
      <Link className="profile-avatar profile-avatar-link" to="/me/profile" aria-label="编辑用户信息">
        <img src={avatarUrl || assets.hero} alt={`${childName}的头像`} />
        <span>编辑头像</span>
      </Link>
      <div className="profile-copy"><p>{childName}的鹿屿森空</p><h1>小小星光探索师</h1><span>已经收集 <b>{stars}</b> 颗星光</span></div>
      <Link className="profile-edit-entry" to="/me/profile">编辑用户信息　→</Link>
    </article>
    <article className="profile-overview">
      <header><div><p>成长主页</p><h2>每一次探索，都留下小小的成长脚印。</h2></div><img src={assets.lumi} alt="露米" /></header>
      <section className="profile-summary-grid">
        <div className="profile-summary-card is-star"><span>✦</span><p>我的星光</p><strong>{stars}</strong><small>完成探索获得</small></div>
        <div className="profile-summary-card"><span>🌱</span><p>成长阶段</p><strong>{profile?.school_stage ? stageLabels[profile.school_stage] : "待设置"}</strong><small>用于匹配内容难度</small></div>
        <div className="profile-summary-card"><span>🪪</span><p>个人档案</p><strong>{profileSummary.join(" · ")}</strong><small>点击头像即可修改</small></div>
      </section>
      <div className="profile-overview-tip"><img src={assets.aduo} alt="阿朵" /><p><b>给家长的小提示</b><span>昵称会用于全站称呼；出生日期和学龄只用于个性化推荐，不会展示给其他家庭。</span></p></div>
      <div className="profile-actions"><Link to="/me/profile">编辑完整成长档案　→</Link><button type="button" onClick={signOut} disabled={busy}>{busy ? "正在退出…" : "退出登录"}</button></div>
    </article>
  </section>;
}